import React from "react";
import "../../../assets/styles/visit-list.scss";

export type VisitItem = {
  id: string;
  /** Üst başlığın ilk kısmı (açık) */
  titleLight?: string;       // Örn: "Hastanemizi"
  /** Vurgulu ikinci kısım */
  titleAccent?: string;      // Örn: "Ziyaret Edin"
  /** Kısa açıklama */
  description?: string;
  /** Google Maps embed URL (output=embed ile) */
  accentColor?: string;
  mapSrc: string;
};

type VisitListProps = {
  items: VisitItem[];
  /** Varsayılan vurgu rengi (item.accentColor yoksa kullanılır) */
  defaultAccent?: string; // örn: "#2cadd2"
};

const VisitList: React.FC<VisitListProps> = ({
  items,
  defaultAccent = "#2cadd2",
}) => {
  return (
    <section className="visit-list">
      <div className="visit-container">
        {items.map((it) => {
          const accent = it.accentColor || defaultAccent;

          return (
            <article
              className="visit-card"
              key={it.id}
              style={{ ["--visit-accent" as any]: accent }}
            >
              <header className="visit-head">
                <h2 className="visit-title">
                  {it.titleLight && <span className="light">{it.titleLight}</span>}{" "}
                  <span className="accent">{it.titleAccent}</span>
                </h2>

                {it.description && (
                  <p className="visit-desc">{it.description}</p>
                )}
              </header>

              <div className="visit-map-wrap">
              <iframe
                src={it.mapSrc}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                title="Harita"
              ></iframe>
              </div>

            </article>
          );
        })}
      </div>
    </section>
  );
};

export default VisitList;
